import React from "react";
import {List} from "../modules/AttendanceReports";

export function AttendanceReportsPage() {
  return (
    <List />
  );
}
